module.exports = ".content{\r\n    margin: auto !important\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/password-reset/password-reset.component.css
// module id = ./src/app/password-reset/password-reset.component.css
// module chunks = main